import React from 'react';
import Icon from '../../../components/AppIcon';

const ProcessingInfo = () => {
  const infoItems = [
    {
      icon: 'Clock',
      title: 'Processing Time',
      description: '24-48 hours for review and approval',
      color: 'primary'
    },
    {
      icon: 'Shield',
      title: 'Approval Criteria',
      description: 'Valid receipt, matching post, and brand guidelines compliance',
      color: 'secondary'
    },
    {
      icon: 'Bell',
      title: 'Notifications',
      description: 'You\'ll receive updates via email and in-app notifications',
      color: 'warning'
    }
  ];

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 border border-border">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Info" size={20} color="var(--color-primary)" />
        <h3 className="text-base md:text-lg font-semibold text-foreground">
          What Happens Next?
        </h3>
      </div>
      <div className="space-y-4">
        {infoItems?.map((item, index) => (
          <div key={index} className="flex items-start gap-3">
            <div className={`w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0 bg-${item?.color}/10`}>
              <Icon name={item?.icon} size={20} color={`var(--color-${item?.color})`} />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm md:text-base font-semibold text-foreground mb-1">
                {item?.title}
              </h4>
              <p className="text-xs md:text-sm text-muted-foreground">
                {item?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-4 p-3 bg-muted/30 rounded-lg border border-border">
        <p className="text-xs text-muted-foreground">
          <strong className="text-foreground">Tip:</strong> Ensure your social post remains public until approval is complete. Private or deleted posts may result in rejection.
        </p>
      </div>
    </div>
  );
};

export default ProcessingInfo;